const STRING_CONST = {
  ['snack']: {
    successColor: 'success',
    successText: 'Se ha guardado correctamente',
    cancelColor: 'default',
    cancelText: 'Se ha cancelado',
    errorColor: 'error',
    errorText: 'No ha sido posible guardar los cambios',
    removeSuccessText: 'Se ha borrado correctamente',
    removeErrorText: 'No ha sido posible borrar el elemento seleccionado'
  }
}

const StringConst = {
  
  install: function (Vue) {
    Vue.prototype.$getStringFor = (componentName, key) => {
      return STRING_CONST[componentName][key]
    }
  }

}
  
export default StringConst